var AbstractWS = require("./AbstractWS");

function MoveConsumerWS(viewModel) {
    var self;
  
    // Predicate this Web Service handler on the Abstract class of a Web
    // Service handler. This establishes core functionality required of
    // these such handlers, which can be overwritten by methods below.
    AbstractWS.apply(this, arguments);
  
    self = this;
    self.method('POST');
    self.name = 'MoveConsumerWS';
    self.viewModel = viewModel;
  
    /**
     * Defines the string to request API services
     *
     * @method serviceURL
     * @returns {String}
     */
    self.serviceURL = function () {
      return '/qless/api/v1/employee/queue/' + self.viewModel.parent.selectedConsumer().queueId + '/move'
    };
  
    return self;
  };
  
  MoveConsumerWS.prototype = Object.create(AbstractWS.prototype);
  MoveConsumerWS.prototype.constructor = MoveConsumerWS;
  
  MoveConsumerWS.prototype.processData = function (data) {
    var self = this;
    var errMsg = null;
  
    // Call the superclass method to perform any core actions
    AbstractWS.prototype.processData.call(self, data, true);
  
    if (self.err) {
      var viewModel = self.viewModel.parent;
      self.conlog(self.err);
  
      if (self.err.rootCauseType == 'AlreadyQueuedException') {
        if (self.isLangUS()) {
          errMsg = self.parent.messagesWS.get('already.queued');
        }
        else {
          errMsg = self.errorMessage();
          if(!errMsg) {
            errMsg = 'The new phone number is already queued.';
          }
        }
  
        self.conlog(errMsg);
        viewModel.errorMessage(errMsg);
        viewModel.showError(true);
      }
    }
  };
  
module.exports = MoveConsumerWS;
